export const addExecutionSource = (execution, userId) => {
  return {
    ...execution,
    source: execution.user_id === userId ? "My Execution" : "Shared With Me",
  };
};
